export enum AlertType {
    Primary = 'primary',
    Info = 'info',
    Secondary = 'secondary',
    Warning = 'warning',
    Medium = 'medium',
    Success = 'success',
    Error = 'error'
}
